import { gql } from '@apollo/client';
import { ProductionOrderInfoShared } from '../fragments';

export default gql`
  query productionOrder($id: ID) {
    productionOrder(id: $id) {
      ...ProductionOrderInfoShared
    }
  }
  ${ProductionOrderInfoShared}
`;
